import isLoggedIn from 'utils/isLoggedIn';
import type { GetServerSideProps } from 'next';
import type { NextPage } from 'next';
import type { ShowroomAppProps } from './_app';
import type { Content } from 'types/Content.interface';
import Dialog from 'components/Dialog';
import Layout from 'layouts/Layout';

export const getServerSideProps: GetServerSideProps = async ({ req, res }) => {
  try {
    const isAuthenticated = isLoggedIn(req, res);
    return {
      props: {
        isAuthenticated
      },
    };
  } catch (error: any) {
    return { props: {} }
  }
}

interface PageProps extends ShowroomAppProps, Content {}

const Contact: NextPage<PageProps> = ({ isAuthenticated }) => {
  return (
    <Layout title="Showroom | kontakt" meta={[]} isAuthenticated={isAuthenticated}>
      <div className="container py-32 mb-14 md:mb-20 max-w-[650px]">

        <h1 className="heading-h1">Kontakt</h1>

        <div className="mx-auto my-8">
          <h3 className="heading-h3 mb-1">Address</h3>
          <p>Rörstrandsgatan 24</p>
          <p>113 40 Stockholm</p>
        </div>

        <div className="mx-auto my-8">
          <h3 className="heading-h3 mb-1">Har du frågor om SHOWROOM?</h3>
          <p>Maila oss på <a className="break-words" href="mailto:morning@morgenland.se">morning@morgenland.se</a></p>
        </div>

      </div>
    </Layout>
  );
};

export default Contact;
